import { connect } from "react-redux";

import Signup from "../components/login/Signup";
import { signupRequest } from "shared-frontend/redux/actions/signup";
import { getRouter } from "../redux/selectors/router/router";
import { getSignupError, getSignupRequestSuccess } from "../redux/selectors/ui/signup";


export const mapDispatchToProps = ( dispatch ) => {
	return {
		attemptSignup: ( data ) => {
			dispatch( signupRequest( data ) );
		},
	};
};

export const mapStateToProps = ( state ) => {
	return {
		stateRouter: getRouter( state ),
		signupError: getSignupError( state ),
		signupRequestSuccess: getSignupRequestSuccess( state ),
	};
};

const SignupContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
)( Signup );

export default SignupContainer;

